import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalBaseComponent } from 'src/app/shared/components/modal-base/modal-base.component';

@Component({
  selector: 'app-validate-email-modal',
  imports: [TranslateModule, ModalBaseComponent],
  templateUrl: './validate-email-modal.component.html',
})
export class ValidateEmailModalComponent {
  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);
}
